export default "__VITE_ASSET__CmG8FcSI__"